import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { VisitaGuiada } from '../../../domain/entities/VisitaGuiada';
import { GetVisitasGuiadasUseCase } from '../../../application/use-cases/GetVisitasGuiadasUseCase';
import { GoogleSheetsVisitaGuiadaRepositoryImpl } from '../../../infrastructure/repositories/GoogleSheetsVisitaGuiadaRepositoryImpl';
import { VisitaGuiadaCard } from '../../components/VisitaGuiadaCard/VisitaGuiadaCard';
import visitasImg from '../../../assets/CasadoPandeiro_exposicao1.jpeg';

const experiencias = [
  {
    titulo: 'Visitas guiadas com mini aula',
    descricao: 'Ideal para turistas e grupos. Conheça a história do pandeiro e experimente tocar o instrumento.',
  },
  {
    titulo: 'Encontros de pandeiro / jam sessions',
    descricao: 'Rodas de pandeiro abertas para troca de experiências entre músicos de diferentes níveis.',
  },
  {
    titulo: 'Programas educativos',
    descricao: 'Para escolas, grupos e instituições. Programas sob medida com foco em cultura e música brasileira.',
  },
];

export const VisitasPage: React.FC = () => {
  const [visitas, setVisitas] = useState<VisitaGuiada[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const visitaRepository = new GoogleSheetsVisitaGuiadaRepositoryImpl();
        const getVisitasUseCase = new GetVisitasGuiadasUseCase(visitaRepository);
        const visitasData = await getVisitasUseCase.execute();
        setVisitas(visitasData);
      } catch (error) {
        console.error('Erro ao carregar visitas:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${visitasImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        role="img"
        aria-label="Visitante na exposição da Casa do Pandeiro"
      >
        <div className="container py-40 md:py-56" />
      </div>

      <div className="container pt-8 pb-16 md:pt-12 md:pb-20 max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl text-primary mb-3">Visitas e Experiências</h1>
        <p className="text-muted-foreground mb-10">Viva a cultura do pandeiro de perto.</p>

        {/* Exposição permanente */}
        <div className="p-6 bg-primary/5 rounded-lg border border-primary/20 mb-10">
          <h2 className="text-xl font-semibold text-primary mb-2">Exposição Permanente</h2>
          <p className="text-lg text-foreground font-medium mb-3">Pandeiros do Brasil: História, Tradição, Inovação</p>
          <p className="text-sm text-muted-foreground leading-relaxed mb-2">
            A exposição permanente é aberta ao público durante todo o horário de funcionamento da casa.
          </p>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Visitas guiadas podem ser agendadas para grupos pelo e-mail{' '}
            <a href="mailto:contato@casadopandeiro.com" className="text-primary underline underline-offset-2 hover:opacity-80">
              contato@casadopandeiro.com
            </a>
          </p>
        </div>

        {/* Próximas visitas guiadas do Google Sheets */}
        {!loading && visitas.length > 0 && (
          <div className="mb-10">
            <h2 className="text-xl text-primary mb-4">Próximas Visitas Guiadas</h2>
            <div className="space-y-3">
              {visitas.map((visita) => (
                <VisitaGuiadaCard key={visita.id.value} visita={visita} />
              ))}
            </div>
          </div>
        )}

        {/* Experiências */}
        <div className="space-y-6">
          {experiencias.map((item) => (
            <div key={item.titulo} className="p-6 bg-card rounded-lg border">
              <h3 className="text-lg text-primary mb-2">{item.titulo}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{item.descricao}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center p-8 bg-secondary/60 rounded-lg">
          <p className="text-foreground mb-4">Quer agendar uma visita ou experiência?</p>
          <Link
            to="/contato"
            className="inline-flex items-center justify-center px-8 py-3 rounded-lg bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity"
          >
            Entre em contato
          </Link>
        </div>
      </div>
    </div>
  );
};
